import React from 'react';
import '../Carousel.css';
import Carousel from './Carousel';

const CarouselContainer = () => {
  return (
    <div className='carousel-container'>
      <Carousel />
    </div>
  );
};

export default CarouselContainer;
